import React, { Component } from "react";
import { createRoot } from "react-dom/client";
import ThemeProviderWrapper from "../hoc/ThemeProviderWrapper";
import { Box, Container } from "@mui/material";
import "../styles/global.css";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import GridContent from "../components/Grid/GridContent";
import FeedToolbar from "../components/FeedToolbar/FeedToolbar";
import CreatorProgramHero from "../components/CreatorProgramHero/CreatorProgramHero";
import CategoryCircles from "../components/CategoryCircles/CategoryCircles";
import { LAYOUT } from "../configuration/theme";

const BREADCRUMBS = [{ name: "Creators", active: true }];

TVSite.isHomePage = true;

class Home extends Component {
    state = {
        loaded: true,
        category: "",
        total: 0,
        sort: "most_recent",
        postSource: null,
    };
    setPostSource = (source) => (open) => {
        this.setState({ postSource: open ? source : null });
    };
    updateRequestParameter = (searchTerm, category, sort, section) => {
        this.setState({ loaded: false });
        if (category) {
            this.setState({ category: category, total: "-" });
        }
        if (sort) {
            this.setState({ sort: sort });
        }
        setTimeout(() => {
            this.setState({ loaded: true });
        }, 300);
    };
    resetRequestParameter = () => {
        this.setState({ loaded: false, category: "", sort: "most_recent" });
        setTimeout(() => {
            this.setState({ loaded: true });
        }, 300);
    };
    clearCategory = () => {
        this.setState({ loaded: false, category: "", total: "-" });
        setTimeout(() => {
            this.setState({ loaded: true });
        }, 300);
    };
    setTotal = (total) => {
        this.setState({ total: total });
    };
    render() {
        const postOpen = this.state.postSource !== null;
        return (
            <ThemeProviderWrapper>
                <Box sx={{ display: postOpen ? "none" : undefined }}>
                <Breadcrumbs breadcrumbsList={BREADCRUMBS} />
                <CreatorProgramHero />
                <Container sx={{ px: LAYOUT.pagePad, pt: "22px" }}>
                    <Box
                        sx={{
                            fontSize: "11px",
                            fontWeight: 700,
                            letterSpacing: "1.4px",
                            textTransform: "uppercase",
                            color: "#7A736E",
                            marginBottom: "12px",
                        }}
                    >
                        Trending
                    </Box>
                </Container>
                </Box>
                <Box sx={{ display: this.state.postSource === "feed" ? "none" : undefined }}>
                    <GridContent
                        variant="rail"
                        paused
                        sort="views"
                        redirect={false}
                        onPostChange={this.setPostSource("rail")}
                    />
                </Box>
                <Box sx={{ display: postOpen ? "none" : undefined }}>
                <CategoryCircles
                    selected={this.state.category}
                    onSelect={(value) => this.updateRequestParameter("", value, this.state.sort)}
                />
                <FeedToolbar
                    total={this.state.total}
                    sort={this.state.sort}
                    category={this.state.category}
                    onSortChange={(value) => this.updateRequestParameter("", this.state.category, value)}
                    onClearCategory={this.clearCategory}
                />
                </Box>
                <Box
                    sx={{
                        display: this.state.postSource === "rail" ? "none" : undefined,
                        backgroundColor: (theme) => (this.state.postSource ? "transparent" : theme.tvp.surface),
                        pt: this.state.postSource ? 0 : LAYOUT.gridPadY,
                        pb: this.state.postSource ? 0 : LAYOUT.gridPadBottom,
                    }}
                >
                    {this.state.loaded && (
                        <GridContent
                            variant="masonry"
                            card
                            redirect={false}
                            query={""}
                            setTotal={this.setTotal}
                            sort={this.state.sort}
                            category={this.state.category}
                            contentTitle={""}
                            search_tag={""}
                            creator_id={""}
                            onPostChange={this.setPostSource("feed")}
                        />
                    )}
                </Box>
            </ThemeProviderWrapper>
        );
    }
}

export default Home;

const targetEl = document.getElementById("app-container");

if (targetEl) {
    const root = createRoot(targetEl);
    root.render(<Home />);
}
